/* hs-eslint ignored failing-rules */

/* eslint-disable promise/catch-or-return */
'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { render } from 'react-dom'; //I18n Configuration

import lang from 'i2l?query=sporks!../lang/en.lyaml';
import BasicPublicI18nSetup from 'I18n/init/setup/BasicPublicI18nSetup';
import http from 'hub-http/clients/noPortalApiClient'; // Redux

import { Provider } from 'react-redux';
import configureStore from './utils/configureStore'; // Configure the router

import { Router } from 'react-router';
import routes from './Routes';
import { getRootUrl } from './utils/urls';
import createHistory from 'hub-pickers-lib/utils/createHistory'; // React-rhumb

import { RhumbProvider } from 'react-rhumb';
import rhumbConfig from '../rhumb-config.yaml';
import historyAdapter from 'react-rhumb/historyAdapterV3';
import NotificationMiddleware from 'ReduxMessenger/middleware/NotificationMiddleware';
import Raven from 'Raven';
export default class Application {
  // Kicks off the app. This is intentionally not in the constructor just in
  // case there is a reason you need to explicitly call init (and don't want it
  // auto-called by importing this module)
  start() {
    if (window.jasmine) return;
    window.AppInstance = this;
    this.init().then(user => {
      const manualLocaleSettings = {
        locale: user.user.locale,
        langEnabled: user.user.languageEnabled
      };
      BasicPublicI18nSetup.setup({
        lang,
        manualLocaleSettings
      }).then(() => {
        this.startReduxAndRaven(user);
      });
    }).done();
  } // Performs all the initialization needed before the main app code can run/render.


  init() {
    return http.get('/login-verify/user-info');
  }

  startReduxAndRaven(user) {
    const middleware = [NotificationMiddleware];
    this.store = configureStore({
      auth: {
        user
      }
    }, middleware);
    Raven.setUserContext({
      id: user.id,
      locale: user.locale
    });
    this.startRouter();
  }

  startRouter() {
    const history = createHistory(getRootUrl());
    render( /*#__PURE__*/_jsx(Provider, {
      store: this.store,
      children: /*#__PURE__*/_jsx(RhumbProvider, {
        captureExceptions: true,
        config: rhumbConfig,
        history: historyAdapter(history),
        children: /*#__PURE__*/_jsx(Router, {
          history: history,
          children: routes
        })
      })
    }), document.getElementsByClassName('page')[0]);
  }

}